import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { SectionLastCTA } from '../../components/SectionLastCTA'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { SectionHomeAiSearch } from './AiSearch/SectionHomeAiSearch'
import { SectionHomeCategories } from './Categories/SectionHomeCategories'
import { SectionHero } from './Hero/SectionHero'
import { SectionHomeMcp } from './Mcp/SectionHomeMcp'
import { SectionHomePricingTeaser } from './SectionHomePricingTeaser'
import { SectionHomeSecurity } from './SectionHomeSecurity'
import { SectionHomeSocialProof } from './SectionHomeSocialProof'
import { SectionHomeSliteAgent } from './SliteAgent/SectionHomeSliteAgent'

export default function SliteHome() {
  const intl = useIntl()
  const routes = useRoutes()

  return (
    <SlitePage canonicalUrl={routes.home()} background="moon-dust-lighter">
      <SectionHero />
      <SectionHomeCategories />
      <SectionHomeSliteAgent />
      <SectionHomeAiSearch />
      <SectionHomeMcp />
      <SectionHomeSecurity />
      <SectionHomeSocialProof />
      <SectionHomePricingTeaser />
      <SectionLastCTA
        background="moon-dust-lighter"
        title={
          <FormattedMessage
            id="home.lastCta.title"
            defaultMessage="A source of truth for your team,{br}and the AI they work with"
            values={{ br: <br /> }}
          />
        }
        buttons={[
          {
            label: intl.formatMessage({
              id: 'home.lastCta.talkToUs',
              defaultMessage: 'Talk to us',
            }),
            href: routes.bookDemo(),
            variant: 'primary-brand',
            size: 'huge',
          },
          {
            label: intl.formatMessage({
              id: 'home.lastCta.pricing',
              defaultMessage: 'See pricing',
            }),
            href: routes.pricing(),
            variant: 'ghost',
          },
        ]}
      />
    </SlitePage>
  )
}
